"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareAddCustomerAddressResponse = prepareAddCustomerAddressResponse;
exports.prepareAddFavoriteMenuItemResponse = prepareAddFavoriteMenuItemResponse;
exports.prepareCustomerAddressesResponse = prepareCustomerAddressesResponse;
exports.prepareDiningChoicesResponse = prepareDiningChoicesResponse;
exports.prepareEditFavoriteMenuItemResponse = prepareEditFavoriteMenuItemResponse;
exports.prepareFavoriteMenuItemsResponse = prepareFavoriteMenuItemsResponse;
exports.prepareGetMenuGroupResponse = prepareGetMenuGroupResponse;
exports.prepareGglocationMenuGroupsResponse = prepareGglocationMenuGroupsResponse;
exports.prepareGglocationsResponse = prepareGglocationsResponse;
exports.prepareImagesResponse = prepareImagesResponse;
exports.prepareIngredientsResponse = prepareIngredientsResponse;
exports.prepareLandingPageResponse = prepareLandingPageResponse;
exports.prepareMenuGroupsResponse = prepareMenuGroupsResponse;
exports.prepareNutritionalCalculationResponse = prepareNutritionalCalculationResponse;
exports.prepareOrdersResponse = prepareOrdersResponse;
exports.preparePlaceOrderResponse = preparePlaceOrderResponse;
exports.preparePricingVariationsResponse = preparePricingVariationsResponse;
exports.prepareRemoveCustomerAddressResponse = prepareRemoveCustomerAddressResponse;
exports.prepareRemoveFavoriteMenuItemResponse = prepareRemoveFavoriteMenuItemResponse;
exports.prepareServingNumberVariationsResponse = prepareServingNumberVariationsResponse;
exports.prepareSettingsResponse = prepareSettingsResponse;
exports.prepareStoreBusyResponse = prepareStoreBusyResponse;
exports.prepareUnavailableIngredientsResponse = prepareUnavailableIngredientsResponse;
exports.responseArrayToObject = responseArrayToObject;
var _lodash = require("lodash");
var commonUtils = _interopRequireWildcard(require("./commonUtils"));
var foodUtils = _interopRequireWildcard(require("./foodUtils"));
var orderUtils = _interopRequireWildcard(require("./orderUtils"));
var gglocationUtils = _interopRequireWildcard(require("./gglocationUtils"));
var _Gglocation = _interopRequireDefault(require("../Gglocation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function prepareOrdersResponse(_ref) {
  let {
    data,
    state,
    requestOptions
  } = _ref;
  const {
    countryName,
    countryCodeAlpha3
  } = data.apiSettings;
  const {
    count,
    previous,
    next,
    results
  } = data.response;
  const {
    userOrders: nextUserOrders,
    userOrderIds: nextUserOrderIds,
    userOrderMenuItems
  } = orderUtils.parseBackendOrders(results, countryName, countryCodeAlpha3);
  let userOrders = {};
  let userOrderIds = [];
  if (requestOptions.clearPrevious) {
    // Remove existing state records
    userOrders = nextUserOrders;
    userOrderIds = nextUserOrderIds;
  } else {
    userOrders = {
      ...state.userOrders,
      ...nextUserOrders
    };
    userOrderIds = (0, _lodash.uniq)([...state.userOrderIds, ...nextUserOrderIds]);
  }
  const userOrdersList = userOrderIds.map(userOrderId => userOrders[userOrderId]);
  const {
    mostFrequentGglocationIds,
    mostRecentGglocationIds
  } = orderUtils.userOrdersGglocations(userOrdersList);
  return {
    response: {
      userOrders,
      userOrderIds,
      userOrderMenuItems,
      mostFrequentGglocationIds,
      mostRecentGglocationIds,
      pageInfo: {
        ...state.pageInfo,
        orders: {
          count,
          previous,
          next,
          currentPage: requestOptions.page
        }
      }
    }
  };
}
function preparePlaceOrderResponse(_ref2) {
  let {
    data,
    state
  } = _ref2;
  const {
    countryName,
    countryCodeAlpha3
  } = data.apiSettings;
  let {
    userOrders,
    userOrderIds,
    userOrderMenuItems
  } = orderUtils.parseBackendOrders([data.response], countryName, countryCodeAlpha3);
  userOrders = {
    ...state.userOrders,
    ...userOrders
  };
  userOrderIds = [...state.userOrderIds, ...userOrderIds];
  const userOrdersList = userOrderIds.map(userOrderId => userOrders[userOrderId]);
  const {
    mostFrequentGglocationIds,
    mostRecentGglocationIds
  } = orderUtils.userOrdersGglocations(userOrdersList);
  return {
    response: {
      userOrders,
      userOrderIds,
      mostFrequentGglocationIds,
      mostRecentGglocationIds,
      userOrderMenuItems: {
        ...state.userOrderMenuItems,
        ...userOrderMenuItems
      }
    }
  };
}
function prepareAddFavoriteMenuItemResponse(_ref3) {
  let {
    data,
    state
  } = _ref3;
  const {
    favoriteMenuItem,
    ingredientServings
  } = foodUtils.parseCustomerFavoriteMenu(data.response);
  return {
    response: {
      favoriteMenuItems: {
        ...state.favoriteMenuItems,
        [favoriteMenuItem.id]: favoriteMenuItem
      },
      favoriteMenuItemIngredientServings: {
        ...state.favoriteMenuItemIngredientServings,
        [favoriteMenuItem.id]: ingredientServings
      },
      favoriteMenuItemIds: [...state.favoriteMenuItemIds, favoriteMenuItem.id]
    }
  };
}
function prepareEditFavoriteMenuItemResponse(_ref4) {
  let {
    data,
    state
  } = _ref4;
  const {
    favoriteMenuItem
  } = foodUtils.parseCustomerFavoriteMenu(data.response);
  return {
    response: {
      favoriteMenuItems: {
        ...state.favoriteMenuItems,
        [favoriteMenuItem.id]: favoriteMenuItem
      }
    }
  };
}
function prepareFavoriteMenuItemsResponse(_ref5) {
  let {
    data,
    state,
    requestOptions
  } = _ref5;
  let favoriteMenuItems = {};
  let favoriteMenuItemIds = [];
  let favoriteMenuItemIngredientServings = {};
  if (!requestOptions.clearPrevious) {
    favoriteMenuItems = state.favoriteMenuItems || {};
    favoriteMenuItemIds = state.favoriteMenuItemIds || [];
    favoriteMenuItemIngredientServings = state.favoriteMenuItemIngredientServings || {};
  }
  const {
    count,
    previous,
    next,
    results
  } = data.response;
  results.map(favoriteMenuItem => {
    const result = foodUtils.parseCustomerFavoriteMenu(favoriteMenuItem);
    favoriteMenuItems[favoriteMenuItem.id] = result.favoriteMenuItem;
    favoriteMenuItemIds.push(favoriteMenuItem.id);
    favoriteMenuItemIngredientServings[favoriteMenuItem.id] = result.frontendIngredientServings;
    return favoriteMenuItem;
  });
  return {
    response: {
      favoriteMenuItems,
      favoriteMenuItemIngredientServings,
      favoriteMenuItemIds: (0, _lodash.uniq)(favoriteMenuItemIds),
      pageInfo: {
        ...state.pageInfo,
        favoriteMenuItems: {
          count,
          previous,
          next,
          currentPage: requestOptions.page
        }
      }
    }
  };
}
function prepareRemoveFavoriteMenuItemResponse(_ref6) {
  let {
    state,
    requestOptions
  } = _ref6;
  const favoriteMenuItemIds = state.favoriteMenuItemIds.filter(id => id !== requestOptions.id);
  const favoriteMenuItems = {};
  favoriteMenuItemIds.forEach(id => {
    favoriteMenuItems[id] = state.favoriteMenuItems[id];
  });
  return {
    response: {
      favoriteMenuItems,
      favoriteMenuItemIds
    }
  };
}
function prepareUnavailableIngredientsResponse(_ref7) {
  let {
    data
  } = _ref7;
  const gglocationDisabledIngredients = {};
  data.response.forEach(ingredient => {
    const gglocationKey = "".concat(ingredient.gglocationType, "_").concat(ingredient.gglocationId);
    if (gglocationDisabledIngredients[gglocationKey]) {
      gglocationDisabledIngredients[gglocationKey].push(ingredient.ingredient);
    } else {
      gglocationDisabledIngredients[gglocationKey] = [ingredient.ingredient];
    }
  });
  return {
    response: {
      gglocationDisabledIngredients
    }
  };
}
const parseCustomerAddressCoordinates = _ref8 => {
  let {
    coordinates
  } = _ref8;
  const regex = /[+-]?\d+(\.\d+)?/g;
  const coordinatesPair = coordinates.match(regex).map(parseFloat);
  return {
    lat: coordinatesPair[2],
    lng: coordinatesPair[1]
  };
};
const parseCustomerAddress = (customerAddress, countryName, countryCodeAlpha3) => {
  const deliveryAddress = commonUtils.parseDeliveryAddress(customerAddress, countryName, countryCodeAlpha3);
  return {
    ...deliveryAddress,
    id: customerAddress.id,
    isDefault: customerAddress.isDefault,
    providerReference: customerAddress.providerReference,
    coordinates: parseCustomerAddressCoordinates(customerAddress)
  };
};
function prepareCustomerAddressesResponse(_ref9) {
  let {
    data
  } = _ref9;
  const {
    countryName,
    countryCodeAlpha3
  } = data.apiSettings;
  const customerAddresses = {};
  const customerAddressIds = new Set();
  data.response.map(customerAddress => {
    customerAddresses[customerAddress.id] = parseCustomerAddress(customerAddress, countryName, countryCodeAlpha3);
    customerAddressIds.add(customerAddress.id);
    return customerAddress;
  });
  return {
    response: {
      customerAddresses,
      customerAddressIds: [...customerAddressIds]
    }
  };
}
function prepareAddCustomerAddressResponse(_ref10) {
  let {
    data,
    state
  } = _ref10;
  const {
    countryName,
    countryCodeAlpha3
  } = data.apiSettings;
  const customerAddress = parseCustomerAddress(data.response, countryName, countryCodeAlpha3);
  return {
    response: {
      customerAddresses: {
        ...state.customerAddresses,
        [customerAddress.id]: customerAddress
      },
      customerAddressIds: commonUtils.removeDuplicates([...state.customerAddressIds, customerAddress.id])
    }
  };
}
function prepareRemoveCustomerAddressResponse(_ref11) {
  let {
    state,
    requestOptions
  } = _ref11;
  const customerAddressIds = state.customerAddressIds.filter(customerAddressId => customerAddressId !== requestOptions.customerAddressId);
  const customerAddresses = {};
  customerAddressIds.forEach(customerAddressId => {
    customerAddresses[customerAddressId] = state.customerAddresses[customerAddressId];
  });
  return {
    response: {
      customerAddresses,
      customerAddressIds
    }
  };
}
function prepareDiningChoicesResponse(_ref12) {
  let {
    data
  } = _ref12;
  const {
    response
  } = data;
  return response.reduce((diningChoiceOptions, diningChoiceOption) => {
    const deliveryPartner = (() => {
      if (!diningChoiceOption.deliveryPartner) {
        return null;
      }
      return {
        baseFee: diningChoiceOption.deliveryPartner.baseFee,
        minimumOrderTotal: diningChoiceOption.deliveryPartner.minimumOrderTotal
      };
    })();
    return {
      response: {
        diningChoiceOptions: {
          ...diningChoiceOptions.response.diningChoiceOptions,
          [commonUtils.toCamelCaseString(diningChoiceOption.slug)]: {
            id: diningChoiceOption.id,
            diningType: diningChoiceOption.diningType,
            isDineIn: diningChoiceOption.isDineIn,
            deliveryPartner
          }
        }
      }
    };
  }, {
    response: {
      diningChoiceOptions: {}
    }
  });
}
function prepareGglocationsResponse(_ref13) {
  let {
    data
  } = _ref13;
  const parsedStores = gglocationUtils.parseInstantGglocations(data.response.stores);
  const parsedPartners = gglocationUtils.parseTimeSlotGglocations(data.response.partners);
  const parsedGglocations = {
    ...parsedStores.gglocations,
    ...parsedPartners.gglocations
  };
  const storeIds = Object.keys(parsedStores.gglocations);
  const partnerIds = Object.keys(parsedPartners.gglocations);
  const timeSlots = {
    ...parsedPartners.timeSlots
  };
  const gglocations = (0, _lodash.mapValues)(parsedGglocations, value => new _Gglocation.default({
    gglocation: value,
    allTimeSlots: timeSlots
  }));
  return {
    response: {
      gglocations,
      storeIds,
      partnerIds,
      timeSlots
    }
  };
}
function responseArrayToObject(_ref14) {
  let {
    data,
    endpointName
  } = _ref14;
  const newObj = {};
  data.response.map(property => {
    newObj[property.id] = property;
    return property;
  });
  return {
    response: {
      [endpointName]: newObj
    }
  };
}
function prepareImagesResponse(_ref15) {
  let {
    data,
    endpointName,
    state
  } = _ref15;
  const images = responseArrayToObject({
    data,
    endpointName
  });
  return {
    response: {
      imageData: {
        ...state.imageData,
        ...images.response
      }
    }
  };
}
function prepareIngredientsResponse(_ref16) {
  let {
    data,
    state
  } = _ref16;
  const ingredients = {};
  const ingredientNutrientAmounts = {};
  data.response.map(ingredient => {
    ingredients[ingredient.id] = {
      ...ingredient,
      price: parseFloat(ingredient.price),
      servingWeight: parseFloat(ingredient.servingWeight),
      nutrientServingWeight: parseFloat(ingredient.nutrientServingWeight),
      nutrientsAmounts: ingredient.id
    };
    ingredient.nutrients.map(ingredientNutrient => {
      const {
        nutrient,
        amount
      } = ingredientNutrient;
      ingredientNutrientAmounts[ingredient.id] = {
        ...ingredientNutrientAmounts[ingredient.id],
        [nutrient]: parseFloat(amount)
      };
      return ingredientNutrient;
    });
    return ingredient;
  });
  return {
    response: {
      ingredients,
      ingredientNutrientAmounts: {
        ...state.ingredientNutrientAmounts,
        ...ingredientNutrientAmounts
      }
    }
  };
}
function prepareGglocationMenuGroupsResponse(_ref17) {
  let {
    data
  } = _ref17;
  const gglocationMenuGroups = {};
  data.response.map(gglocation => {
    const gglocationId = "".concat(gglocation.gglocationType, "_").concat(gglocation.gglocationId);
    gglocationMenuGroups[gglocationId] = gglocation.menus;
    return gglocation;
  });
  return {
    response: {
      gglocationMenuGroups
    }
  };
}
function prepareServingNumberVariationsResponse(_ref18) {
  let {
    data
  } = _ref18;
  const servingNumberVariations = data.response.map(servingNumberVariation => ({
    ...servingNumberVariation,
    menuUuid: servingNumberVariation.menuUuid || null,
    defaultServingNumber: parseFloat(servingNumberVariation.defaultServingNumber)
  }));
  return {
    response: {
      servingNumberVariations
    }
  };
}
function prepareSettingsResponse(_ref19) {
  let {
    data,
    state
  } = _ref19;
  const images = commonUtils.arrayToObject(data.response.webclientBannerImages);
  const displaySettings = commonUtils.arrayToObject(data.response.displaySettings);
  return {
    response: {
      imageData: {
        ...state.imageData,
        bannerImages: {
          ...images
        }
      },
      settings: {
        ...data.response,
        displaySettings
      }
    }
  };
}
function preparePricingVariationsResponse(_ref20) {
  let {
    data
  } = _ref20;
  const pricingVariations = data.response.map((pricingVariation, id) => {
    /* pricingVariation.limit acts as maximumServings with 1 minimumServings */
    const minimumServings = pricingVariation.limit ? 1.0 : parseFloat(pricingVariation.minimumServings) || null;
    const maximumServings = pricingVariation.limit ? parseFloat(pricingVariation.limit) : parseFloat(pricingVariation.maximumServings) || null;
    return {
      ...pricingVariation,
      id,
      menuUuid: pricingVariation.menuUuid || null,
      price: parseFloat(pricingVariation.price),
      taxAmount: parseFloat(pricingVariation.taxAmount),
      serving: undefined,
      minimumServings,
      maximumServings
    };
  });
  return {
    response: {
      pricingVariations
    }
  };
}
function prepareMenuGroupsResponse(_ref21) {
  let {
    data,
    state
  } = _ref21;
  let menuItems = {};
  let menuItemIngredientServings = {};
  let apiIdMenuItemNames = {};
  const menuGroups = {};
  data.response.map(menuGroup => {
    const result = foodUtils.parseMenus(menuGroup.menus, menuGroup.id);
    menuGroups[menuGroup.id] = Object.keys(result.menuItems);
    menuItems = {
      ...menuItems,
      ...result.menuItems
    };
    menuItemIngredientServings = {
      ...menuItemIngredientServings,
      ...result.menuItemIngredientServings
    };
    apiIdMenuItemNames = {
      ...apiIdMenuItemNames,
      ...result.apiIdMenuItemNames
    };
    return menuGroup;
  });
  return {
    response: {
      menuItems: {
        ...state.menuItems,
        ...menuItems
      },
      menuItemIngredientServings: {
        ...state.menuItemIngredientServings,
        ...menuItemIngredientServings
      },
      menuGroups: {
        ...state.menuGroups,
        ...menuGroups
      },
      apiIdMenuItemNames
    }
  };
}
function prepareGetMenuGroupResponse(_ref22) {
  let {
    data,
    state
  } = _ref22;
  const menuGroup = data.response;
  const result = foodUtils.parseMenus(menuGroup.menus, menuGroup.id);
  return {
    response: {
      menuGroups: {
        ...state.menuGroups,
        [menuGroup.id]: Object.keys(result.menuItems)
      },
      menuItems: {
        ...state.menuItems,
        ...result.menuItems
      },
      menuItemIngredientServings: {
        ...state.menuItemIngredientServings,
        ...result.menuItemIngredientServings
      },
      apiIdMenuItemNames: {
        ...state.apiIdMenuItemNames,
        ...result.apiIdMenuItemNames
      }
    }
  };
}
function prepareStoreBusyResponse(_ref23) {
  let {
    data,
    state
  } = _ref23;
  const newStoreBusyDetails = (0, _lodash.keyBy)(data.response, "storeId");
  return {
    response: {
      storeBusyDetails: {
        ...state.storeBusyDetails,
        ...newStoreBusyDetails
      }
    }
  };
}
function prepareLandingPageResponse(_ref24) {
  let {
    data
  } = _ref24;
  return {
    response: {
      ...data.response
    }
  };
}
function prepareNutritionalCalculationResponse(_ref25) {
  let {
    data
  } = _ref25;
  return {
    response: {
      nutrients: {
        ...foodUtils.parseNutrientAmounts(data.response.nutrients)
      }
    }
  };
}